import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import { CardViewer } from '@/components/CardViewer';
import NotFound from './NotFound';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
      return <CardViewer pubkey={decoded.data} npub={identifier} />;

    case 'nprofile': {
      const pubkey = decoded.data.pubkey;
      return <CardViewer pubkey={pubkey} npub={nip19.npubEncode(pubkey)} />;
    }

    default:
      return <NotFound />;
  }
}
